import React, { useState, useMemo, useEffect, useCallback } from "react"
import { Paper, Box } from "@mui/material"

import SideBarLayout from "src/v2/layout/side-bar-layout"

import MotorService from "src/services/motor-service"
import { dispatchSnackbar } from "src/v2/components/SnackBar/snackbar-bus"

import CetipVersaoEventosFilterComponent from "../components/CetipVersaoFilter/cetip-versao-eventos-filter-component"

import ResumoConsolidadoStatus from "./componentes/resumo_consolidados_table"
import StatusAnaliticoCadastro from "./componentes/status_analitico_consolidados_table"

import ButtonWithIcon from "src/v2/components/Button/Button"
import { ReactComponent as FileIcon } from "src/v2/assets/icons/file-icon.svg"

const StatusCadastroPage = () => {
  const motorService = useMemo(() => new MotorService(), [])

  const [loading, setLoading] = useState(false)

  const [cetip, setCetip] = useState("")
  const [versaoDocumento, setVersaoDocumento] = useState("")

  const [resumoData, setResumoData] = useState([])
  const [analiticoData, setAnaliticoData] = useState([])

  const fetchData = useCallback(async () => {
    try {
      setLoading(true)

      const [resumo, analitico] = await Promise.all([
        motorService.getStatusResumo({ cetip, versaoDocumento }),
        motorService.getStatusAnalitico({ cetip, versaoDocumento }),
      ])

      setResumoData(resumo?.body?.data ?? [])
      setAnaliticoData(analitico?.body?.data ?? [])
    } catch (error) {
      dispatchSnackbar("Erro ao carregar status do cadastro", "error")
    } finally {
      setLoading(false)
    }
  }, [motorService, cetip, versaoDocumento])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  const exportFile = () => {
    try {
      motorService.exportStatusAnaliticoCsv({
        cetip,
        versaoDocumento,
      })
    } catch (error) {
      dispatchSnackbar("Erro ao exportar CSV", "error")
    }
  }

  return (
    <SideBarLayout
      title="Status do Cadastro"
      header
      headerTitle="Status do Cadastro"
      headerImage={"/background/cadastro-background-header.jpg"}
      loading={false}
    >

      <Paper sx={{ p: 3, borderRadius: 0, mb: 2, mt: -2}}>
        <ResumoConsolidadoStatus
          loading={loading}
          data={resumoData}
        />
      </Paper>

      <Paper sx={{ p: 3, borderRadius: 0, mb: 2 }}>
        <Box
          display="flex"
          alignItems="auto"
          flexWrap="wrap"
          sx={{ mb: 2 }}
        >
          <CetipVersaoEventosFilterComponent
            setCetip={setCetip}
            fullWidth={false}
            setVersao={setVersaoDocumento}
            returnCetipVersao={(c, v) => {
              setCetip(c)
              setVersaoDocumento(v)
            }}
            clearFilter={() => {
              setCetip("")
              setVersaoDocumento("")
            }}
          />

          <Box sx={{ ml: "auto", mt: -7}}>
            <ButtonWithIcon
              icon={<FileIcon />}
              onClick={exportFile}
            >
              Exportar CSV
            </ButtonWithIcon>
          </Box>
        </Box>

        <StatusAnaliticoCadastro
          loading={loading}
          data={analiticoData}
        />
      </Paper>
    </SideBarLayout>
  )
}

export default StatusCadastroPage